import * as React from "react";

function SvgFilledEmptyCircle(props) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}><circle cx={12} cy={12} r={11.5} fill="#F6F7F8" stroke="#DADADA" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/filled-empty-circle_f6feb7.svg";
export { SvgFilledEmptyCircle as ReactComponent };